import { Button } from '@slal/ui/buttons';
import { ClockIcon } from '@slal/ui/icons';
import { useAnalytics } from '~/hooks';
import { EstimatedCompletionTime, StyledStartApplicationButtonsWrapper, StyledStartApplicationLink } from './styles';

export const StartApplication = () => {
    const { pushEvent } = useAnalytics();
    return (
        <StyledStartApplicationButtonsWrapper>
            <StyledStartApplicationLink
                onClick={() => pushEvent({ eventLabel: 'Next button click' })}
                to="/application/advice"
            >
                <Button fullWidth={true}>Next</Button>
            </StyledStartApplicationLink>
            <EstimatedCompletionTime tag="span">
                <ClockIcon /> 20 mins
            </EstimatedCompletionTime>
        </StyledStartApplicationButtonsWrapper>
    );
};
